export const categories = [
  {
    id: 'first-deposit',
    name: '首存送彩金',
    slug: 'first-deposit',
    description: '首次存款即可获得丰厚彩金奖励，多档存款金额对应不同彩金额度，最高可获888元彩金！',
    icon: 'ri-money-dollar-circle-line',
    count: 128,
  },
  {
    id: 'sign-in',
    name: '签到送彩金',
    slug: 'sign-in',
    description: '每日签到领取彩金，连续签到天数越多彩金越丰厚，轻松积累不间断！',
    icon: 'ri-calendar-check-line',
    count: 96,
  },
  {
    id: 'invite',
    name: '邀请好友送彩金',
    slug: 'invite',
    description: '邀请好友注册并完成首存，双方均可获得彩金奖励，邀请越多奖励越多！',
    icon: 'ri-user-add-line',
    count: 75,
  },
  {
    id: 'daily',
    name: '天天送彩金',
    slug: 'daily',
    description: '每日限时彩金活动，参与即可领取，天天都有新惊喜，彩金拿不停！',
    icon: 'ri-gift-line',
    count: 156,
  },
  {
    id: 'vip',
    name: 'VIP专属彩金',
    slug: 'vip',
    description: 'VIP会员专享高额彩金福利，等级越高彩金越多，尊享特权不容错过！',
    icon: 'ri-vip-crown-line',
    count: 42,
  },
  {
    id: 'festival',
    name: '节日送彩金',
    slug: 'festival',
    description: '节假日专属彩金活动，春节、中秋、国庆等重大节日限时放送！',
    icon: 'ri-fire-line',
    count: 63,
  },
];

export const promotions = [
  {
    id: 1,
    title: '新会员注册即送38元彩金',
    category: 'first-deposit',
    categoryName: '首存送彩金',
    description: '新用户完成注册并绑定手机号，即可领取38元新人专属彩金，无需存款直接到账！',
    imageSeq: 'promo-new-register',
    imageQuery: 'Lucky%20red%20gold%20Chinese%20new%20year%20style%20background%20with%20glowing%20envelope%20and%20gold%20coins%2C%20festive%20atmosphere%2C%20warm%20lighting%2C%20clean%20composition%2C%20elegant%20minimalist%2C%20soft%20bokeh%20background%2C%20celebration%20theme',
    amount: '38元',
    platform: '官方平台',
    tag: '热门',
    featured: true,
  },
  {
    id: 2,
    title: '首存100送88元彩金',
    category: 'first-deposit',
    categoryName: '首存送彩金',
    description: '首次存款满100元即可获得88元彩金奖励，5倍流水即可提款，超低门槛轻松领取！',
    imageSeq: 'promo-first-deposit',
    imageQuery: 'Red%20and%20gold%20lucky%20money%20theme%20with%20Chinese%20ingots%20and%20coins%20on%20warm%20gradient%20background%2C%20fortune%20concept%2C%20clean%20minimal%20product%20photography%20style%2C%20soft%20shadows%2C%20elegant%20composition',
    amount: '88元',
    platform: '官方平台',
    tag: '推荐',
    featured: true,
  },
  {
    id: 3,
    title: '每日签到领彩金 连续7天最高得188元',
    category: 'sign-in',
    categoryName: '签到送彩金',
    description: '每日签到即可领取彩金，连续签到7天可额外获得最高188元彩金大奖，坚持就是胜利！',
    imageSeq: 'promo-sign-in',
    imageQuery: 'Warm%20golden%20calendar%20with%20red%20highlights%20on%20soft%20cream%20background%2C%20daily%20checkin%20reward%20concept%2C%20lucky%20Chinese%20theme%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20minimalist%20composition',
    amount: '最高188元',
    platform: '官方平台',
    tag: '每日',
    featured: false,
  },
  {
    id: 4,
    title: '邀请好友注册各得58元彩金',
    category: 'invite',
    categoryName: '邀请好友送彩金',
    description: '分享专属邀请链接给好友，好友注册并完成首存后，双方各得58元彩金，上不封顶！',
    imageSeq: 'promo-invite',
    imageQuery: 'Two%20hands%20sharing%20a%20glowing%20golden%20gift%20box%20on%20warm%20red%20gradient%20background%2C%20friendship%20and%20reward%20concept%2C%20Chinese%20lucky%20style%2C%20soft%20elegant%20lighting%2C%20clean%20composition',
    amount: '58元×2',
    platform: '官方平台',
    tag: '热门',
    featured: true,
  },
  {
    id: 5,
    title: 'VIP2级以上专享 每月168元彩金',
    category: 'vip',
    categoryName: 'VIP专属彩金',
    description: 'VIP2级及以上会员每月可领取168元专属彩金，等级越高金额越大，尊享特权福利！',
    imageSeq: 'promo-vip',
    imageQuery: 'Luxurious%20golden%20VIP%20crown%20with%20red%20velvet%20texture%20on%20dark%20warm%20background%2C%20premium%20membership%20concept%2C%20elegant%20Chinese%20style%2C%20soft%20dramatic%20lighting%2C%20clean%20minimalist%20composition',
    amount: '168元/月',
    platform: '官方平台',
    tag: 'VIP',
    featured: false,
  },
  {
    id: 6,
    title: '国庆狂欢 存款即送双倍彩金',
    category: 'festival',
    categoryName: '节日送彩金',
    description: '国庆期间存款即可获得双倍彩金奖励，最高可获666元！限时活动，错过再等一年！',
    imageSeq: 'promo-festival',
    imageQuery: 'Chinese%20national%20day%20celebration%20with%20red%20lanterns%20and%20golden%20fireworks%20on%20warm%20festive%20background%2C%20lucky%20and%20joyful%20atmosphere%2C%20clean%20design%2C%20soft%20lighting%2C%20elegant%20composition',
    amount: '最高666元',
    platform: '官方平台',
    tag: '限时',
    featured: true,
  },
  {
    id: 7,
    title: '天天抽奖 100%中奖率',
    category: 'daily',
    categoryName: '天天送彩金',
    description: '每日免费抽奖一次，100%中奖！彩金、实物奖品等你来拿，每日参与赢取惊喜好礼！',
    imageSeq: 'promo-daily-lottery',
    imageQuery: 'Golden%20spinning%20wheel%20with%20red%20prizes%20on%20warm%20festive%20background%2C%20lucky%20draw%20concept%2C%20Chinese%20style%2C%20celebration%20atmosphere%2C%20clean%20composition%2C%20soft%20golden%20lighting',
    amount: '随机',
    platform: '官方平台',
    tag: '每日',
    featured: false,
  },
  {
    id: 8,
    title: '首存500送388元超值彩金',
    category: 'first-deposit',
    categoryName: '首存送彩金',
    description: '首次存款满500元即可领取388元超值彩金，8倍流水即可提款，超高回报率！',
    imageSeq: 'promo-first-500',
    imageQuery: 'Stack%20of%20golden%20coins%20and%20red%20envelopes%20on%20warm%20cream%20background%2C%20wealth%20and%20fortune%20concept%2C%20Chinese%20lucky%20aesthetic%2C%20clean%20product%20photography%2C%20soft%20elegant%20lighting',
    amount: '388元',
    platform: '官方平台',
    tag: '超值',
    featured: false,
  },
];

export const platforms = [
  {
    id: 1,
    name: '官方主平台',
    rating: 4.9,
    reviewCount: 12580,
    description: '官方直营平台，资金安全有保障，彩金到账快，提款秒到，千万玩家信赖之选。',
    features: ['资金安全', '彩金秒到', '提款无忧', '24h客服'],
  },
  {
    id: 2,
    name: '财富娱乐城',
    rating: 4.8,
    reviewCount: 8620,
    description: '老牌平台运营8年，信誉卓著，彩金活动丰富多样，每日都有新惊喜。',
    features: ['老牌信誉', '活动丰富', '高额彩金', 'VIP特权'],
  },
  {
    id: 3,
    name: '好运来平台',
    rating: 4.7,
    reviewCount: 6350,
    description: '新锐平台，界面简洁流畅，彩金领取流程简单快捷，深受年轻玩家喜爱。',
    features: ['界面简洁', '领取快捷', '新人友好', '活动频多'],
  },
  {
    id: 4,
    name: '金彩国际',
    rating: 4.8,
    reviewCount: 9120,
    description: '国际品牌运营，多币种支持，彩金额度高，适合大额玩家参与。',
    features: ['国际品牌', '多币种', '高额彩金', '专业服务'],
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最新送彩金平台大盘点：哪个平台送得最多？',
    slug: 'best-bonus-platforms-2026',
    category: 'first-deposit',
    categoryName: '首存送彩金',
    excerpt: '本文为您详细盘点2026年各大平台的最新送彩金政策，从彩金额度、流水要求、提款速度等多个维度进行对比分析，帮助您找到最划算的送彩金平台。',
    content: '...',
    publishDate: '2026-08-10',
    readTime: '8分钟',
    imageSeq: 'article-platforms',
    imageQuery: 'Comparison%20chart%20with%20golden%20and%20red%20highlights%20on%20clean%20warm%20background%2C%20analysis%20concept%2C%20Chinese%20business%20style%2C%20professional%20clean%20design%2C%20soft%20lighting',
  },
  {
    id: 2,
    title: '首存送彩金全攻略：如何最大化领取首存彩金？',
    slug: 'first-deposit-guide',
    category: 'first-deposit',
    categoryName: '首存送彩金',
    excerpt: '首存送彩金是最常见的彩金类型，但不同平台的规则差异很大。本文将教您如何选择最佳的首存方案，让每一分存款都物超所值。',
    content: '...',
    publishDate: '2026-08-08',
    readTime: '6分钟',
    imageSeq: 'article-first-deposit-guide',
    imageQuery: 'Strategy%20guide%20with%20golden%20coins%20and%20red%20notebook%20on%20warm%20desk%20background%2C%20financial%20planning%20concept%2C%20Chinese%20lucky%20style%2C%20clean%20composition%2C%20soft%20lighting',
  },
  {
    id: 3,
    title: '签到送彩金真的靠谱吗？实测5大平台签到福利对比',
    slug: 'sign-in-bonus-review',
    category: 'sign-in',
    categoryName: '签到送彩金',
    excerpt: '我们实测了5大主流平台的签到送彩金功能，从每日彩金额度、连续签到奖励、提款条件等方面进行详细对比，给你最真实的体验报告。',
    content: '...',
    publishDate: '2026-08-06',
    readTime: '10分钟',
    imageSeq: 'article-sign-in-review',
    imageQuery: 'Calendar%20with%20red%20checkmarks%20and%20golden%20stars%20on%20warm%20cream%20background%2C%20review%20and%20comparison%20concept%2C%20Chinese%20style%2C%20clean%20modern%20design%2C%20soft%20lighting',
  },
  {
    id: 4,
    title: '邀请好友送彩金终极玩法：月入过万不是梦',
    slug: 'invite-friends-strategy',
    category: 'invite',
    categoryName: '邀请好友送彩金',
    excerpt: '邀请好友送彩金不仅自己能拿，好友也能得。掌握正确的推广方法，邀请彩金收入完全可以超过普通上班族，本文将全面解析邀请玩法的各种技巧。',
    content: '...',
    publishDate: '2026-08-04',
    readTime: '12分钟',
    imageSeq: 'article-invite-strategy',
    imageQuery: 'Social%20network%20with%20golden%20connections%20and%20red%20reward%20icons%20on%20warm%20background%2C%20referral%20marketing%20concept%2C%20Chinese%20style%2C%20clean%20modern%20design%2C%20soft%20lighting',
  },
  {
    id: 5,
    title: 'VIP彩金特权深度解析：不同等级能拿多少？',
    slug: 'vip-bonus-explained',
    category: 'vip',
    categoryName: 'VIP专属彩金',
    excerpt: 'VIP等级从V1到V10，每个等级对应的彩金福利各不相同。本文将为您详细解析各级VIP的彩金权益，帮您规划升级路线。',
    content: '...',
    publishDate: '2026-08-02',
    readTime: '7分钟',
    imageSeq: 'article-vip-explained',
    imageQuery: 'Luxurious%20golden%20VIP%20card%20with%20red%20velvet%20on%20warm%20elegant%20background%2C%20premium%20membership%20concept%2C%20Chinese%20style%2C%20clean%20composition%2C%20soft%20dramatic%20lighting',
  },
  {
    id: 6,
    title: '节日送彩金时间表：2026全年节日彩金日历',
    slug: 'festival-bonus-calendar-2026',
    category: 'festival',
    categoryName: '节日送彩金',
    excerpt: '整理了2026年全年的节日送彩金时间表，包括春节、元宵、端午、中秋、国庆等重要节日，让您提前做好领取彩金的准备，不错过任何一个节日福利。',
    content: '...',
    publishDate: '2026-07-30',
    readTime: '5分钟',
    imageSeq: 'article-festival-calendar',
    imageQuery: 'Chinese%20festival%20calendar%20with%20red%20dates%20and%20golden%20decorations%20on%20warm%20background%2C%20yearly%20planning%20concept%2C%20Chinese%20traditional%20style%2C%20clean%20design%2C%20soft%20lighting',
  },
];

export const faqs = [
  {
    question: '什么是送彩金活动？',
    answer: '送彩金活动是平台为回馈玩家推出的优惠福利，玩家通过注册、首存、签到、邀请好友等方式可以免费获得彩金奖励。彩金可用于平台游戏或满足一定条件后提款。',
  },
  {
    question: '彩金可以直接提款吗？',
    answer: '大部分彩金需要满足一定的流水（投注）要求后才能提款。不同彩金类型的流水倍数不同，一般在3-10倍之间。建议领取彩金前仔细阅读活动规则。',
  },
  {
    question: '如何领取注册送彩金？',
    answer: '完成注册并绑定手机号后，系统会自动将彩金发放到您的账户。部分活动可能需要手动在活动页面点击领取。彩金通常在5分钟内到账。',
  },
  {
    question: '一个账号可以多次领取彩金吗？',
    answer: '同一类型的彩金通常每个账号只能领取一次，但不同活动的彩金可以分别领取。平台严禁一人多号刷彩金行为，违规者将被永久封禁。',
  },
  {
    question: '彩金到账慢是什么原因？',
    answer: '彩金通常在5分钟到2小时内到账。如超过2小时未到账，建议检查是否满足领取条件，或联系在线客服查询。高峰期可能会有延迟。',
  },
  {
    question: '邀请好友送彩金有上限吗？',
    answer: '大部分平台对于邀请好友送彩金不设上限，邀请越多奖励越多。但部分平台会设置每日或每月的领取上限，具体请查看各平台的活动规则。',
  },
];